
export const INIT    = 'init'    // no status
export const ACTIVE  = 'active'  // highlighted in menu
export const STARTED = 'started' // rode draad, started
export const STOPPED = 'stopped' // rode draad, stopped